import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  removeItem(event) {
    event.preventDefault()

    const container_selector = event.params.container_selector || '.nested-fields'
    const item = event.target.closest(container_selector)
    const inputDestroy = item.querySelector("input[name*='_destroy']")
    if (inputDestroy) {
      inputDestroy.value = 'true'
    }

    item.classList.add('d-none')
  }
}
